import { Transform, TransformFnParams } from "class-transformer";
import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { toEuros } from "@/utils/numberUtils";

const transformToEuros = ({ value }: TransformFnParams): number => toEuros(value as number);

export class PayrollLineDto extends BaseEntityDto {
  conceptKey: string;

  label: string;

  quantity: number;

  quantityScale: number;

  quantityUnit?: string;

  @Transform(transformToEuros)
  unitPrice: number;

  @Transform(transformToEuros)
  amount: number;

  position: number;

  details?: Record<string, unknown>;

  isManuallyEdited?: boolean;
}
